import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle } from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";

import * as actions from '../../actions/oldtickets';

class OldTickets extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
        };

    }

    componentDidMount() {

        this.props.get();
    }

    render() {

        return(
            <div className="view">

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Old Tickets</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                            <ReactTable
                              data      = {this.props.oldtickets.data}
                              className = "-striped -highlight"
                              columns   = {[
                                {Header: 'No.', accessor: 'No'},
                                {Header: 'Cliente', accessor: 'cliente'},
                                {Header: 'Empresa', accessor: 'empresa'},
                                {Header: 'Telefono', accessor: 'telefono'},
                                {
                                    Header: 'Estatus',
                                    accessor: 'estatus',
                                    style: {paddingLeft: '40px'},
                                    Cell: row => (
                                      <span>
                                          <span style={{
                                              color: row.value === 'Inicial' ? '#00c853'
                                              : row.value === 'Proceso' ? '#ffbf00'
                                              : row.value === 'Finalizado' ? '#2962ff'
                                              : '#ff1f1f',
                                              transition: 'all .3s ease'
                                          }}>
                                          &#x25cf;
                                          </span>&nbsp;
                                          {row.value}
                                      </span>
                                      )
                                }
                              ]}
                              filterable 
                              defaultPageSize={10} 
                              defaultFilterMethod={(filter, row) => {
                                var patt = new RegExp(filter.value, "i");
                                return row[filter.id].search(patt) > -1 || row[filter.id].search(patt) > -1;
                              }}
                              SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>
                                            <dl className="row">
                                                <dt className="col-sm-3 text-truncate">Asistencia</dt>
                                                <dd className="col-sm-9">{row.original.Asistencia}</dd>

                                                <dt className="col-sm-3 text-truncate">Hora</dt>
                                                <dd className="col-sm-9">{row.original.hora}</dd>

                                                <dt className="col-sm-3 text-truncate">Descripción</dt>
                                                <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.Descripcion}}></dd>
                                            </dl>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                            />
                        </CardBlock>
                    </Card>
                </div>

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        oldtickets: state.oldtickets,
    }
};

export default connect(mapStateToProps, actions)(OldTickets)



// WEBPACK FOOTER //
// ./src/views/oldtickets/index.js